/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Mon Apr 01 2024
 **/

import styled from "@emotion/styled";

import { Column, Row, Typography } from "@/frameworks/designStuff/components";

export const StateUploadPopupContainer = styled.div<{ zIndex: number }>`
	position: fixed;
	right: 24px;
	bottom: 24px;
	z-index: ${({ zIndex }) => zIndex};
	user-select: none;
`;

export const StyledFileStateUploadPopup = styled(Column)`
	padding: 24px;
	border-radius: 12px;
	background: ${({ theme }) => theme.colors.neutral_00_100};
	width: 360px;
	box-shadow: 0px 12px 20px 0px rgba(0, 0, 0, 0.2);
`;

export const FileExtensionWrapper = styled(Column)`
	width: 28px;
	height: 28px;
`;

export const UploadStateWrapper = styled(Column)<{ status: "success" | "error" | "pending" | "cancel" }>`
	width: 24px;
	height: 24px;
	border-radius: 50%;
	background: ${({ theme, status }) => {
		if (status === "success") {
			return theme.colors.accent_40_100;
		}

		if (status === "error") {
			return theme.colors.neutral_40_100;
		}

		if (status === "cancel") {
			return theme.colors.error_60_100;
		}
	}};
`;

export const FileName = styled(Typography)`
	width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const StyledFileUploadItem = styled(Row.li)`
	width: 100%;
	border-radius: 8px;
	&:hover {
		background: ${({ theme }) => theme.colors.neutral_10_100};
		.cancel {
			display: flex;
		}
		.pending {
			display: none;
		}
	}
	.cancel {
		display: none;
	}
	cursor: pointer;
`;
